import React, { useContext } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import { EventContext } from "@gp/components";
import { openMobileEventStatisticsPopUp } from "@utils";
import { ProviderNameEnum } from "@gp/models";

export default observer(function StatisticsButton(props: {
	isOfferButton?: boolean;
	isSmallIcon?: boolean;
}) {
	const event = useContext(EventContext);

	const isBREvent =
		event?.source?.providerName == ProviderNameEnum.BetRadar ? true : false;
	const betRadarId = isBREvent ? event.source?.matchId : null;

	if (betRadarId == null) {
		return null;
	}

	//#region css classes

	const buttonClasses = classNames(
		"at-actionStats",
		{
			match__details__btn: props.isOfferButton,
			event__top__btn: !props.isOfferButton,
		},
		"btn",
		{
			"btn--square--reset btn--ghost": props.isOfferButton,
			"btn--square btn--square--sml btn--secondary--inverted":
				!props.isOfferButton,
		},
		{
			"is-disabled": !betRadarId,
		}
	);

	const iconClasses = classNames(
		{
			match__details__icon: props.isOfferButton,
			event__actions__icon: !props.isOfferButton,
		},
		"u-icon",
		{
			// "u-icon--tny": props.isSmallIcon,
			// "u-icon--sml": !props.isSmallIcon || !props.isOfferButton,
			"u-icon--xsml": props.isOfferButton,
			"u-icon--sml": !props.isOfferButton,
			"u-icon--action--stats--active":
				(!props.isOfferButton || props.isOfferButton) && betRadarId,
			"u-icon--action--stats--disabled": !betRadarId,
		}
	);
	//#endregion css classes

	if (!betRadarId) {
		return null;
	}

	return (
		<button
			className={buttonClasses}
			type="button"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();

				openMobileEventStatisticsPopUp(betRadarId);
			}}
		>
			<i className={iconClasses} />
		</button>
	);
});
